(() => {
  'use strict';

  const exactTranslations = new Map([
    ['主页', 'Home'],
    ['首页', 'Home'],
    ['产品目录', 'Shop'],
    ['商品目录', 'Shop'],
    ['目录', 'Shop'],
    ['联系我们', 'Contact'],
    ['关于我们', 'Our Story'],
    ['珍珠风格', 'Pearl Styles'],
    ['珍珠指南', 'Pearl Guide'],
    ['博客', 'Pearl Journal'],
    ['产品', 'Products'],
    ['商品', 'Products'],
    ['搜索', 'Search'],
    ['购物车', 'Cart'],
    ['我的账户', 'My Account'],
    ['账户', 'Account'],
    ['登录', 'Log in'],
    ['注册', 'Create account'],
    ['结账', 'Checkout'],
    ['继续购物', 'Continue shopping'],
    ['返回首页', 'Back to Home'],
    ['查看全部', 'View all'],
    ['了解更多', 'Learn more'],
    ['订阅', 'Subscribe'],
    ['关闭', 'Close'],
    ['菜单', 'Menu']
  ]);

  const attributes = ['title', 'aria-label', 'placeholder'];
  const chinesePattern = /[\u3400-\u4DBF\u4E00-\u9FFF]/;

  function translateValue(value) {
    if (!value || !chinesePattern.test(value)) return value;

    const leading = value.match(/^\s*/)?.[0] || '';
    const trailing = value.match(/\s*$/)?.[0] || '';
    const core = value.trim();
    const exact = exactTranslations.get(core);

    return exact ? `${leading}${exact}${trailing}` : value;
  }

  function translateTextNodes(root) {
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          const parent = node.parentElement;
          if (!parent || ['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA'].includes(parent.tagName)) {
            return NodeFilter.FILTER_REJECT;
          }
          return chinesePattern.test(node.nodeValue || '')
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT;
        }
      }
    );

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      const translated = translateValue(node.nodeValue);
      if (translated !== node.nodeValue) node.nodeValue = translated;
    });
  }

  function translateAttributes(root) {
    const elements = root.querySelectorAll
      ? root.querySelectorAll('[title], [aria-label], [placeholder]')
      : [];

    elements.forEach((element) => {
      attributes.forEach((attribute) => {
        if (!element.hasAttribute(attribute)) return;
        const current = element.getAttribute(attribute);
        const translated = translateValue(current);
        if (translated !== current) element.setAttribute(attribute, translated);
      });
    });
  }

  function applyEnglishGuard(root = document.body) {
    if (!root) return;
    document.documentElement.lang = 'en';
    translateTextNodes(root);
    translateAttributes(root);
  }

  function start() {
    applyEnglishGuard();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const translated = translateValue(node.nodeValue);
            if (translated !== node.nodeValue) node.nodeValue = translated;
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            applyEnglishGuard(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
